export type SignInLegalParams = {
    verificationToken: string;
    inn: string;
};
export type SignInLegalResponse = {
    access_token: string;
    moderated: boolean;
};

export type SignInIndividualParams = {
    verificationToken: string;
};
export type SignInIndividualResponse = {
    access_token: string;
    moderated: boolean;
};
export type SignUpLegalParams = {
    name: string;
    lastName: string;
    middleName?: string;
    email: string;
    inn: string;
    verificationToken: string;
};
export type SignUpLegalResponse = {
    access_token: string;
    moderated: boolean;
};
export type SignUpIndividualParams = {
    name: string;
    lastName: string;
    middleName?: string;
    email: string;
    verificationToken: string;
};
export type SignUpIndividualResponse = {
    access_token: string;
    moderated: boolean;
};
export type SendSmsParams = {
    // телефон отправляется первый раз
    phone?: string;
    // при последующих запросах нужно отправлять токен, полученный от первого запроса
    sendToken?: string;
};
export type SendSmsResponse = {
    send_token: string;
};
export type VerifySmsCodeParams = {
    sendToken: string;
    code: string;
};
export type VerifySmsCodeResponse = {
    verification_token: string;
};
export type VerifyAuthParams = {
    accessToken: string;
};
export type VerifyAuthResponse = {
    valid: boolean;
    moderated: boolean;
};
export type VerifyPhoneParams = {
    phone: string;
};
export type VerifyPhoneResponse = {
    exist: boolean;
};
export type GetLegalsParams = {
    inn: string;
};
export type LegalResponse = {
    id: number;
    name: string;
    inn: string;
    requisites?: string;
    address?: string;
};
export type GetLegalsResponse = LegalResponse[];

export type CartOrderSuccessInfoParams = {
    orderId: string;
};

export type CartOrderItemSuccessInfoResponse = {
    id: number;
    name: string;
    price?: {
        current: number;
        old: number;
    };
    quantity: number;
    currency: string;
    sum: number;
    marking: string;
    url: string;
    image: string;
};

export type CartOrderSuccessInfoResponse = {
    order_id: number;
    name: string;
    order_date: string;
    email: string;
    phone: string;
    payment_method: string;
    delivery: string;
    region_title: string;
    region: string;
    order_items: CartOrderItemSuccessInfoResponse[];
    total_sum: number;
    total_sale: number;
    total?: {
        products_amount: number;
        products_type_amount: number;
        price_without_sale: number;
        price: number;
        sale: number;
    };
    is_complect_discount: number;
};

export type CompanyPerson = {
    id: number;
    name: string;
    surname: string;
    phone: string;
    email: string;
};

export type CompanyDocument = {
    id: number;
    file_name: string;
    url: string;
};

export type CompanyPartner = {
    id: number;
    name: string;
    type: UserType;
    balance?: number;
    members: CompanyPerson[];
    documents?: CompanyDocument[];
};

export type CompanyPartnersResponse = {
    partner_name: string;
    counterparties: CompanyPartner[];
};

export type UpdateUserParams = {
    name?: string;
    email?: string;
    phone?: string;
    surname?: string;
    verificationToken?: string;
};

export type UpdateUserResponse = {
    id: string;
    type: UserType;
    legal: string;
    inn: string;
    member: {
        name: string;
        position: string;
    };
};
export type CartCompanyResponse = {
    id: number;
    title: string;
    inn: string;
};
export type GetCartCompaniesResponse = CartCompanyResponse[];

export type GetCurrentDiscountResponse = {
    level: number;
    summary: number;
};

export type FavoriteProductResponse = {
    id: number;
    preview: string;
    article: string;
    title: string;
    discount?: boolean;
    price: {
        old: number;
        current: number;
    };
};

export type GetFavoriteProductsResponse = FavoriteProductResponse[];

export type LocationObject = {
    id: number;
    latitude: string;
    longitude: string;
    address: string;
};

export type GetLocationsResponse = LocationObject[];

export type UpdateLocationsParams = LocationObject;

export type UpdateLocationsResponse = LocationObject;

export type CreateLocationsParams = {
    latitude: string;
    longitude: string;
    address: string;
};

export type CreateLocationsResponse = LocationObject;

export type DeleteLocationsParams = {
    id: number;
};

export type DeleteLocationsResponse = {
    deleted: boolean;
};

export type GetPickupLocationsParams = {
    region: string;
};

export type PickupLocationResponse = {
    id: number;
    mapUrl: string;
    address: string;
    metroList?: string[];
};

export type GetPickupLocationsResponse = PickupLocationResponse[];

export type FilterOrderType = 'my' | 'rest';

export type GetOrdersParams = {
    type: FilterOrderType;
};

export enum DeliveryStatusType {
    Completed = 'completed',
    Wait = 'wait',
    Cancel = 'cancel',
}

export enum OrderStatusType {
    Waiting = 'Waiting',
    Ready = 'Ready',
    Cancelled = 'Canceled',

    NotPaidNotShipped = 'NotPaidNotShipped',
    NotPaidPartiallyShipped = 'NotPaidPartiallyShipped',
    NotPaidReadyForPickup = 'NotPaidReadyForPickup',
    NotPaidFullyShipped = 'NotPaidFullyShipped',

    PartiallyPaidNotShipped = 'PartiallyPaidNotShipped',
    PartiallyPaidPartiallyShipped = 'PartiallyPaidPartiallyShipped',
    PartiallyPaidReadyForPickup = 'PartiallyPaidReadyForPickup',
    PartiallyPaidFullyShipped = 'PartiallyPaidFullyShipped',

    FullyPaidNotShipped = 'FullyPaidNotShipped',
    FullyPaidPartiallyShipped = 'FullyPaidPartiallyShipped',
    FullyPaidReadyForPickup = 'FullyPaidReadyForPickup',
    FullyPaidFullyShipped = 'FullyPaidFullyShipped',
}

export type OrderListItem = {
    id: number;
    datetime: string;
    status: OrderStatusType;
    /** покупатель */
    customer: {
        type: UserType;
        name: string;
        inn: string;
        member: {
            name: string;
            email: string;
            phone: string;
        };
    };
    /** кто оформил */
    author: string;

    total: {
        /** количество товаров */
        total: number;
        /** скидка */
        sale: number;
        /** стоимость доставки */
        shipping: number;
        /** общая сумма заказа */
        summary: number;
    };
};
export type GetOrdersResponse = OrderListItem[];

export type GetOrderDetailsParams = {
    id: string;
    type: 'counterparties' | 'my';
};

export type Product = {
    id: number;
    marking: string;
    picture: string;
    url: string;
    name: string;
    price: number;
    price_old: number;
    price_total?: number;
    quantity: number;
};

export type Delivery = {
    id: number;
    name: string;
    status: DeliveryStatusType;
    address: string;
    date_receiving: string;
    comment: string;
    goods: Product[];
};

export type OrderTotalInfo = {
    /** кол-во товаров */
    goods: number;
    /** скидка */
    sale: number;
    /** стоимость доставки */
    shipping: number;
    /** общая стоимость */
    summary: number;
    /** оплачено */
    paid?: number;
};

export type OrderDocument = {
    id: number;
    file_name: string;
    url: string;
};

export type GetOrderDetailsResponse = {
    id: string;
    status: OrderStatusType;
    datetime: string;
    comment: string;
    customer: {
        type: UserType;
        name: string;
        inn: string;
        member: {
            name: string;
            email: string;
            phone: string;
        };
    };
    deliveries: Delivery[];
    total: OrderTotalInfo;
    documents: OrderDocument[];
};

export type DeleteOrderParams = {
    id: string;
};
export type DeleteOrderResponse = {
    canceled: boolean;
};

export type OrderComplaintParams = {
    id: string;
};
export type OrderComplaintResponse = {
    complaint: boolean;
};

export type UploadFilesParams = {
    files: {
        name: string;
    }[];
};
export type UploadFilesResponse = {
    status: string;
};
export type ForwardDocumentParams = {
    documentId: number;
    email: string;
};
export type ForwardDocumentResponse = {
    sended: boolean;
};
export enum UserType {
    Legal = 'legal',
    Individual = 'individual',
    Dealer = 'dealer',
}
export type GetCurrentUserResponse = {
    id: number;
    type: UserType;
    legal: string;
    inn: string;
    moderated: boolean;
    balance?: number;
    member: {
        name: string;
        last_name: string;
        position: string;
        phone: string;
        email: string;
    };
};

export type SummaryOrder = {
    id: number;
    status: OrderStatusType;
    datetime: string;
};

export type SummaryLocation = {
    id: number;
    address: string;
};

export type SummaryPartners = {
    id: number;
    name: string;
};

export type SummaryDiscount = {
    level: number;
};

export type Requisites = {
    file_name: string;
    id: number;
    url: string;
};

export type SummaryInfoResponse = {
    orders: {
        list: SummaryOrder[];
        total: number;
    };
    locations: SummaryLocation[];
    partners: SummaryPartners[];
    discount: SummaryDiscount;
    requisites?: Requisites;
};

export type FeedbackResponse = {
    sended: boolean;
};

export type GenerateCartPdfResponse = {
    data: string;
};

export type GetPdfFromHtmlParams = {
    path_to_html: string;
};

export type GetPdfFromHtmlResponse = {
    data: {
        path_to_pdf: string;
        pdf_file_path: string;
    };
};

export type CartOrderSubmitParams = {
    name: string;
    phone: string;
    email: string;
    shipping: string;
    pickup?: string;
    address?: string;
    payment: string;
    comment?: string;
    subscribe?: string;
    companyId?: number;
    companyName?: string;
};

export type CartOrderSubmitResponse = {
    data: {
        redirect: string;
    };
    error?: Record<string, string>;
};

export type WarehouseCategoryInfoResponse = {
    id: number;
    iconUrl?: string;
    warehouseIconUrl?: string;
    code: string;
    name: string;
    /** кол-во товаров в категории, без учета подкатегорий */
    productsCount: number;
    /** кол-во товаров во всех вложенных категориях, включая текущую */
    productsTotalCount: number;
    categoriesCount: number;
};

export type WarehouseRootCategoryResponse = WarehouseCategoryInfoResponse & {
    categories: WarehouseCategoryInfoResponse[];
};

export type GetWarehouseRootCategoriesResponse = {
    categories: WarehouseRootCategoryResponse[];
};

export type GetWarehouseSubcategoriesParams = {
    categoryId: number;
    inStock: boolean;
    onTheWay: boolean;
};

export type GetWarehouseSubcategoriesResponse = {
    category: WarehouseCategoryInfoResponse;
    subcategories: WarehouseCategoryInfoResponse[];
};

export type GetWarehouseProductsParams = {
    page: number;
    categoryId: number;
    limit: number;
    sort?: {type: string; order: string};
    inStock: boolean;
    onTheWay: boolean;
};

export type WarehouseProductResponse = Omit<
    Product,
    'quantity' | 'price_total'
> & {
    /** количество остатков товара в наличии на складе */
    remains: number;
    /** количество товара в пути */
    onTheWay: number;
};

export type GetWarehouseProductsResponse = {
    category: WarehouseCategoryInfoResponse;
    products: WarehouseProductResponse[];
    pagination: {
        currentPage: number;
        totalPages: number;
        totalItems: number;
    };
};

export type SolutionProductsParams = {
    apiUrl: string;
};

export type SolutionProductItemResponse = {
    id: number;
    title: string;
    link: string;
    group_id?: string;
    article: string;
    preview: string;
    image_large: string;
    images: string[];
    count: number;
    price: {
        old: number;
        current: number;
    };
    counter: {
        min: number;
        addBy: number;
        readonly?: boolean;
    };
    discount: boolean;
    deleted: boolean;
};

export type SolutionProductsResponse = {
    data: {
        groups?: {
            goods_parent_id?: number;
            parent_id?: string;
            name: string;
            goods: SolutionProductItemResponse[];
            additionalGoods?: SolutionProductItemResponse[];
        }[];
        goods?: SolutionProductItemResponse[];
    };
};
